import React from "react";
import { Grid, Typography, Box } from "@mui/material";

const CalendarDayCell = ({
  date,
  selectedDate,
  onSelect,
  availableSlotsMap,
  isDateDisabled,
  minDate,
  maxDate,
  today,
  colorRules = [],
}) => {
  const dateKey = date.format("YYYY-MM-DD");
  const isToday = date.isSame(today, "day");
  const isSelected = selectedDate?.isSame(date, "day");

  const isTooEarly = date.isBefore(minDate, "day");
  const isTooLate = date.isAfter(maxDate, "day");
  const isBlocked = isDateDisabled(date);
  const isInPast = date.isBefore(today, "day");

  const slotCount = availableSlotsMap[dateKey] || 0;
  const hasSlots = !isInPast && slotCount > 0;

  const disabled =
    isTooEarly || isTooLate || isBlocked || isInPast || !hasSlots;

  const getDotColor = (count, rules = []) => {
    for (const rule of rules) {
      const { minSlots, maxSlots, color } = rule;
      const matchesMin = minSlots == null || count >= minSlots;
      const matchesMax = maxSlots == null || count <= maxSlots;
      if (matchesMin && matchesMax) return color || "grey.500";
    }
    return "grey.500";
  };

  const dotColor = getDotColor(slotCount, colorRules);

  return (
    <Grid
      item
      xs={1.71}
      sm={1.71}
      sx={{
        p: 1,
        textAlign: "center",
        borderRadius: 2,
        bgcolor: isSelected ? "primary.main" : "white",
        color: isSelected ? "#fff" : disabled ? "grey.500" : "text.primary",
        border: isToday ? "1px solid" : undefined,
        borderColor: isToday ? "primary.main" : undefined,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.4 : 1,
        transition: "all 0.2s",
        height: { xs: "64px", sm: "80px" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        "&:hover": {
          bgcolor: !disabled && !isSelected ? "grey.200" : undefined,
          border: !disabled && !isSelected ? "1px solid #ccc" : undefined,
        },
      }}
      onClick={() => !disabled && onSelect(date)}>
      <Typography variant="body1" fontWeight="bold" lineHeight={1}>
        {date.date()}
      </Typography>

      {!disabled && (
        <Box
          mt={0.5}
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            bgcolor: dotColor,
          }}
        />
      )}
    </Grid>
  );
};

export default CalendarDayCell;
